import { Injectable } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Injectable({
  providedIn: 'root',
})
export class DigitalDataService {
  digitalData;
  version;
  defaultSectionsObj;
  constructor(private readonly acmicService: AcmicService) {
    this.defaultSectionsObj = {
      section1: '',
      section2: '',
      section3: '',
      section4: '',
      section5: '',
      section6: '',
      section7: '',
      section8: '',
    };
    this.digitalData = {
      version: '',
      page: {
        brand: '',
        channel: '',
        url: '',
        page_type: '',
        language: '',
        country: '',
        error_type: '',
        error_message: '',
        ...this.defaultSectionsObj,
      },
    };
  }

  setVersion(version) {
    this.digitalData = { ...this.digitalData, version };
  }

  updateDigitalData(currentRoute) {
    const obj = this.constructDigitalObject(currentRoute);
    this.digitalData.page = { ...this.digitalData.page, ...obj.page };
    this.setDigitalDataToWin();
  }

  setDigitalDataToWin() {
    window['digitalData'] = this.digitalData;
  }

  getSection1FromPath(route) {
    return route.split('/').pop();
  }

  getSection2FromPath(route) {
    const path = route.split('/');
    return path.length > 2 ? path[1] : '';
  }

  getPageType(route) {
    const pagePath = route.split('?')[0];
    let pageType;
    switch (pagePath) {
      case '':
      case '/login':
        pageType = 'homepage';
        break;
      case '/make-payment':
        pageType = 'landing';
        break;
      case '/contact':
        pageType = 'contact';
        break;
      default:
        pageType = 'private area';
    }
    return pageType;
  }

  setErrorDetails(type, error) {
    const message = error.Message ? error.Message : error.message;
    this.digitalData.page.error_type = type;
    this.digitalData.page.error_message = message;
    this.setDigitalDataToWin();
  }

  clearErrorDetails() {
    this.digitalData.page.error_type = '';
    this.digitalData.page.error_message = '';
  }
  getNonRouteParamRoutes(route) {
    route = route.split('/');
    route.shift();
    const routePathLen = route.length;
    if (routePathLen > 2) {
      const lastButOneElm = route[routePathLen - 2];
      if (
        (lastButOneElm.length === 10 && !isNaN(+lastButOneElm)) ||
        lastButOneElm[0].toUpperCase() === lastButOneElm[0]
      ) {
        route.splice(routePathLen - 2, 1);
      }
    }
    return route;
  }

  buildSecProp(nonParmRoutes) {
    const dynamicSecObj = nonParmRoutes.reduce((accObj, curElm, i) => {
      return { ...accObj, ...{ [`section${i + 1}`]: curElm } };
    }, {});
    return { ...this.defaultSectionsObj, ...dynamicSecObj };
  }

  constructDigitalObject(route) {
    this.clearErrorDetails();
    const nonParmRoutes = this.getNonRouteParamRoutes(route);
    const sectObj = this.buildSecProp(nonParmRoutes);
    return {
      page: {
        brand: this.acmicService.isACMIC() ? 'acmic' : 'mapfre',
        channel: 'digital business',
        language: 'en',
        country: 'us',
        page_type: this.getPageType(route),
        url: (window && window.location && window.location.href) || '',
        ...sectObj,
      },
    };
  }
}
